/*
API requests related to assets
*/
import { apiRequest } from '../../plugins/core/dd.data.connect.js'

export const allCustomFieldTypes = (params) => {
    var p = new Promise((resolve, reject) => {
      apiRequest('GET', `/custom-field-types`, null, params).then((res) => {
        resolve(res.data)
      }).catch((e) => {
        reject(e)
      })
    })
    return p
  }
  
  export const allCustomFields = (params) => {
    var p = new Promise((resolve, reject) => {
      apiRequest('GET', `/custom-fields`, null, params).then((res) => {
        resolve(res.data)
      }).catch((e) => {
        reject(e)
      })
    })
    return p
  }

  export const protectedCustomFields = (params) => {
    var p = new Promise((resolve, reject) => {
      apiRequest('GET', `/custom-fields/protected`, null, params).then((res) => {
        resolve(res.data)
      }).catch((e) => {
        reject(e)
      })
    })
    return p
  }

  export const searchCustomFields = (data, params) => {
    var p = new Promise((resolve, reject) => {    
      apiRequest('GET', `/custom-fields/search/${data.value}`, null, params).then((res) => {
      
        // add empty pagination object if res.data is empty
        if(!res.data.data || res.data.data.length==0){      
          res.data.meta = {pagination:{count:0,current_page:0,per_page:0,total:0,total_pages:0}}
        }      
        resolve(res.data)
      }).catch((e) => {
        reject(e.data)
      })
    })
    return p
  }

  export const saveCustomField = (data) => {
    var p = new Promise((resolve, reject) => {
      let method
      let url
      
      if(data.id){
        url =  `/custom-fields/${data.id}`
        method = 'PUT'
      }
      else{
        url =  `/custom-fields`
        method = 'POST'
      }      
      apiRequest(method,url, data).then((res) => {
           resolve(res.data.data)
         }).catch((e) => {
           reject(e);
         })
       })
     return p;
  }

  export const saveCustomFieldAllowedValue = (data) => {
    var p = new Promise((resolve, reject) => {
      let method
      let url
      if(!data.custom_field_id){
        throw Error("custom_field_id is mandatory")
      }

      if(data.key){
        url =  `/custom-fields/${data.custom_field_id}/allowed-values/${data.key}`
        method = 'PUT'
      }
      else{
        url =  `/custom-fields/${data.custom_field_id}/allowed-values`
        method = 'POST'
      }      
      apiRequest(method,url, data).then((res) => {
           resolve(res.data.data)
         }).catch((e) => {
           reject(e);
         })
       })
     return p;
  }

  export const deleteCustomField = (data) => {
    var p = new Promise((resolve, reject) => {
      let method
      let url
      
      if(data.id){
        url =  `/custom-fields/${data.id}`
        method = 'DELETE'
      }  
      else{
        reject("no custom field id given");
      }

      apiRequest(method,url, data).then((res) => {
           resolve(res.data.data)
         }).catch((e) => {
           reject(e);
         })
       })
     return p;
  }  

  export const deleteCustomFieldAllowedValue = (data) => {
    var p = new Promise((resolve, reject) => {
      let method
      let url

      if(!data.custom_field_id){
        throw Error("custom_field_id is mandatory")
      }
      if(!data.key){
        throw Error("key is mandatory")
      }      

      url =  `/custom-fields/${data.custom_field_id}/allowed-values/${data.key}`
      method = 'DELETE'
    
      apiRequest(method,url, data).then((res) => {
           resolve(res.data.data)
         }).catch((e) => {
           reject(e);
         })
       })
      return p;
  }    

  export const saveCustomFieldsOnAssetGroup = (data) => {
    var p = new Promise((resolve, reject) => {
      let method
      let url
      if(!data.assetGroupId){
        throw Error("assetGroupId is mandatory")
      }
  
      url =  `/asset-groups/${data.assetGroupId}/mass-assign-custom-fields`
      method = 'POST'
      
      apiRequest(method, url, data.customFields).then((res) => {
           resolve(res.data.data)
         }).catch((e) => {
           reject(e);
         })
       })
     return p;
  }
  
/*
  export const addCustomFieldToAssetGroup = (data) => {
    var p = new Promise((resolve, reject) => {
      let method
      let url
      
      if(data.id){
        url =  `/custom-fields/${data.asset_group_id}`
        method = 'POST'
      }  
      else{
        reject("no custom field id given");
      }

      apiRequest(method,url, data).then((res) => {
           resolve(res.data.data)
         }).catch((e) => {
           reject(e);
         })
       })
     return p;
  }    
*/